import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { PagedResult, ResultOfT } from '../models/response/result';
import { GetActivityLogsRequestModel, GetAdminActivityLogsRequestModel } from '../models/request/activity-log';
import { ActivityLogResponseModel, AdminActivityLogResponseModel } from '../models/response/activity-log-response';

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService extends BaseService {

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  GetCustomerActivityLogs(reqModel: GetActivityLogsRequestModel) {
    return this.post<ResultOfT<PagedResult<ActivityLogResponseModel>>>('AuditLog/GetCustomerActivityLogs', reqModel);
  }
  

  GetAdminActivityLogs(reqModel: GetAdminActivityLogsRequestModel) {
    return this.post<ResultOfT<PagedResult<AdminActivityLogResponseModel>>>('AuditLog/GetAdminActivityLogs', reqModel);
  }

  GetAdminLogTypes() {
    return this.get<ResultOfT<string[]>>('AuditLog/GetAdminLogTypes');
  }

  GetCustomerLogTypes(companyId: number) {
    return this.get<ResultOfT<string[]>>('AuditLog/GetCustomerLogTypes' + '/' + companyId);
  }

  GetCompanyNames() {
    return this.get<ResultOfT<string[]>>('AuditLog/GetCompanyNames');
  }

  GetCabinetNames(companyId: number) {
    return this.get<ResultOfT<string[]>>('AuditLog/GetCabinetNames' + '/' + companyId);
  }

  GetTypeNames(companyId: number) {
    return this.get<ResultOfT<string[]>>('AuditLog/GetTypeNames' + '/' + companyId);
  }
  
  ExportCustomerActivityLogsCsv(reqModel: GetActivityLogsRequestModel) {
    return this.downloadBlobFile('AuditLog/ExportCustomerActivityLogsCsv', reqModel);
  }

  ExportAdminActivityLogsCsv(reqModel: GetAdminActivityLogsRequestModel) {
    return this.downloadBlobFile('AuditLog/ExportAdminActivityLogsCsv', reqModel);
  }
}

